import Helmet from 'react-helmet';
import type { FunctionComponent } from 'react';
import type { InjectedRouter } from 'react-router';
import FooterText from './generic/FooterText';
import Redirect from './generic/Redirect';
import Navigation from './Navigation';
import { window } from '../globals';
import type { RouterProps } from '../types';

const ONBOARDING_ROUTE = '/onboarding';

type Props = RouterProps & {
  router: InjectedRouter;
};

/**
 * Main "dashboard" component which renders everything in the app.
 */
const Dashboard: FunctionComponent<Props> = ({ children, location, router, ...props }) => {
  // We only want to redirect users that are logged in. If they're not logged in, they'll see the public version of the
  // page or a Not Found error if the project is private.
  const shouldRedirect = window.user &&
    !window.user?.organization &&
    location.pathname !== ONBOARDING_ROUTE &&
    !location.pathname.startsWith('/account/join-org');

  if (shouldRedirect) {
    return <Redirect to={ONBOARDING_ROUTE} />;
  }

  return (
    <div id="dashboard-main">
      <Helmet title="Component Inventory" titleTemplate="%s | FOSSA" />
      <Navigation
        location={location}
        router={router}
          // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        />
      {children}
      <FooterText />
    </div>
  );
};

export default Dashboard;
